import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-prepare-recipe',
  templateUrl: './prepare-recipe.component.html',
  styleUrls: ['./prepare-recipe.component.scss']
})
export class PrepareRecipeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
